import React, { useState } from 'react';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { useMutation } from '@apollo/client';
import moment from 'moment';

// custom components
import { captureException } from '@playbookux/playbook-web-core';
import ParticipantDidNotShowModal from './participant-did-not-show-modal/index';
import withProjectSidebar from '../../../components/with-project-sidebar';
import Tabs from '../../../constants/tabs';
import ScheduleLink from './schedule-link';
import ConfirmedSessions from './confirmed-sessions';
import Settings from './settings';
import Availability from './availability';

import {
  UPDATE_BUFFER_TIME,
} from './graphql';

import {
  Container,
} from './styles';

const ProjectSchedule = (props) => {
  const {
    project,
    companyId: currentCompanyId,
    scope,
  } = props;

  const {
    id: projectId,
    bufferTime,
    maxBookings,
    bookingNotice,
    timeZone,
    segments,
    participantPrice: price,
  } = project;

  const [openModal, setOpenModal] = useState(false);
  const [testSessionId, setTestSessionId] = useState(null);
  const [firstName, setFirstName] = useState('');
  const [currentTimezone, setCurrentTimezone] = useState(moment.tz.guess() || timeZone);

  const [updateBuffer] = useMutation(UPDATE_BUFFER_TIME);

  const handleModalOpen = (idTestSession, name) => {
    setTestSessionId(idTestSession);
    setFirstName(name);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleUpdateDropdown = async (value, attribute) => {
    try {
      await updateBuffer({
        variables: {
          id: projectId,
          attributes: {
            [attribute]: value,
          },
        },
      });
    } catch (error) {
      captureException('HANDLE_UPDATE_DROPDOWN_FAILED', error);
    }
  };

  const handleChangeTimezoneDropdown = (value, name) => {
    handleUpdateDropdown(value, name);
    if (name === 'timeZone') {
      setCurrentTimezone(value);
    }
  };

  return (
    <>
      <Container>
        <ScheduleLink
          project={project}
          segment={segments[0]}
        />
        <ConfirmedSessions
          timeZone={currentTimezone}
          project={project}
          handleModalOpen={handleModalOpen}
          scope={scope}
        />
        {scope === 'user' && (
          <>
            <Settings
              bufferTime={bufferTime}
              maxBookings={maxBookings}
              bookingNotice={bookingNotice}
              onChange={(name, value) => handleChangeTimezoneDropdown(value, name)}
            />
            <Availability
              companyId={currentCompanyId}
              timeZone={currentTimezone}
              onChangeTimezone={(value) => handleChangeTimezoneDropdown(value, 'timeZone')}
              project={project}
            />
          </>
        )}

        {openModal && (
          <ParticipantDidNotShowModal
            openModal={openModal}
            testSessionId={testSessionId}
            onClose={handleCloseModal}
            firstName={firstName}
            price={price}
          />
        )}

      </Container>
    </>
  );
};

ProjectSchedule.propTypes = {
  project: PropTypes.shape({
    bufferTime: PropTypes.number,
    id: PropTypes.string,
    timeZone: PropTypes.string,
    maxBookings: PropTypes.number,
    bookingNotice: PropTypes.number,
    participantPrice: PropTypes.number,
    segments: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
    })),
  }).isRequired,
  companyId: PropTypes.string.isRequired,
  scope: PropTypes.string.isRequired,
};

export default compose(
  withProjectSidebar({ selectedTab: Tabs.PROJECT }),
)(ProjectSchedule);
